<template>
	<LabeledFieldLayout
		class-name="labeled-calendar-picker"
		:is-valid="isValid"
	>
		<TeamingCalendarPicker
			:disabled="disabled"
			:disabled-days="disabledDays"
			:filter-criteria="filterCriteria"
			:isValid="isValid"
			:max-date="maxDate"
			:min-date="minDate"
			:timezone="timezone"
			:value="dateValue"
			@change="onChange"
		/>
	</LabeledFieldLayout>
</template>

<script>
import { isJSDate } from "@teaming/common-util";
import LabeledFieldLayout from "./LabeledFieldLayout";
import TeamingCalendarPicker from "../TeamingCalendarPicker";

export default {
	name: "LabeledCalendarPicker",
	emits: [ "change", ],
	components: {
		LabeledFieldLayout,
		TeamingCalendarPicker,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		disabledDays: {
			type: Array,
			default: () => ( [] ),
		},
		filterCriteria: {
			type: Object,
			default: () => ( {
				ordinal: 0,
				weekday: 0,
			} ),
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		maxDate: {
			type: Date,
			default: null,
		},
		minDate: {
			type: Date,
			default: null,
		},
		timezone: {
			type: String,
			default: "local",
		},
		value: {
			type: [ Date, String, ],
			required: true,
		},
	},
	computed: {
		dateValue() {
			if ( isJSDate( this.value ) ) {
				return this.value;
			}
			return new Date( this.value );
		},
	},
	methods: {
		onChange( option ) {
			this.$emit( "change", option );
		},
	},
};
</script>

<style lang="scss" scoped>
.labeled-calendar-picker {
	.teaming-drop-down {
		width: 100%;
	}
}
</style>
